import { useState, useMemo } from "react";
import { IconX } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import { useLanguage } from "../../../context/LanguageContext";

type CityItem = string; // or interface if you have more properties

type ViewCitiesModalProps = {
  open: boolean;
  onClose: () => void;
  citiesItem?: CityItem[];
};

const ViewCitiesModal = ({
  open,
  onClose,
  citiesItem = [],
}: ViewCitiesModalProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { language } = useLanguage();

  const getCityDisplayName = (cityStr: string) => {
    if (!cityStr) return "";
    if (cityStr.includes("::")) {
      const parts = cityStr.split("::");
      return (language === "ar" && parts[1]) ? parts[1] : parts[0];
    }
    return cityStr;
  };

  const filteredCities = useMemo(() => {
    return citiesItem.filter((city) => {
      if (!city) return false;
      const lowercaseSearch = searchTerm.toLowerCase();
      if (city.includes("::")) {
        const parts = city.split("::");
        return parts[0].toLowerCase().includes(lowercaseSearch) || parts[1].toLowerCase().includes(lowercaseSearch);
      }
      return city.toLowerCase().includes(lowercaseSearch);
    });
  }, [citiesItem, searchTerm]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-[#F7F6F2] rounded-2xl w-full max-w-md max-h-[90vh] flex flex-col overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#d2d2d2]">
          <h1 className="text-2xl font-semibold">
            View Cities ({filteredCities.length})
          </h1>
          <button
            onClick={onClose}
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer hover:bg-gray-200 transition-colors"
            aria-label="Close modal"
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="p-4">
          <NormalSearch
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            
          />
        </div>

        <div className="overflow-y-auto flex-1 px-4 pb-4">
          <div className="flex flex-col ">
            {filteredCities.length > 0 ? (
              filteredCities.map((city, index) => (
                <div
                  key={`${city}-${index}`}
                  className={`flex items-center py-1 ${
                    filteredCities.length > 999 ? "gap-10" : "gap-4"
                  }`}
                >
                  {/* <span className="text-left font-semibold px-3 w-8">
                    {index + 1}.
                  </span> */}
                  <div className=" px-4 py-1 rounded-full">
                    {getCityDisplayName(city)}
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center py-4 text-gray-500">No cities found</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCitiesModal;
